import React from 'react';
import { Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { getImageUrl } from '../../constants/routes';

const FallbackAvatar = ({ 
  src, 
  size = 32, 
  user = null,
  showPersonIcon = true,
  sx = {},
  ...props 
}) => {
  const [hasError, setHasError] = React.useState(false);
  const imageUrl = src ? getImageUrl(src) : null;

  const getFallbackInitial = () => {
    if (!user) return 'M';
    return user.first_name ? user.first_name[0].toUpperCase() :
           user.last_name ? user.last_name[0].toUpperCase() :
           user.email ? user.email[0].toUpperCase() : 'M';
  };

  const handleError = (e) => {
    console.warn('Avatar image failed to load:', e.target.src);
    e.target.src = '';
    setHasError(true);
  };

  return (
    <Avatar
      src={!hasError ? imageUrl : undefined}
      onError={handleError}
      sx={{ 
        width: size, 
        height: size,
        bgcolor: imageUrl && !hasError ? 'transparent' : 'rgba(255, 255, 255, 0.1)',
        ...sx
      }}
      {...props}
    >
      {(!imageUrl || hasError) && (
        showPersonIcon ? 
          <PersonIcon sx={{ fontSize: size * 0.5, color: 'rgba(255, 255, 255, 0.3)' }} /> :
          getFallbackInitial()
      )}
    </Avatar>
  );
};

export default FallbackAvatar;
